import { useState } from 'react';
import { downloadStateExhibit } from '@uplift/api';
import { useAlert } from '@uplift/ui-v2';


export const useDownloadStateExhibit = () => {
  const alert = useAlert();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadExhibit = async (stateExhibitId: string, filename: string) => {
    setIsDownloading(true);
    try {
      const result = await downloadStateExhibit(stateExhibitId);
      const url = window.URL.createObjectURL(result.data);
      const a = window.document.createElement('a');

      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch {
      alert.error('Failed to download state exhibit');
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, downloadExhibit };
};
